import { render, staticRenderFns } from "./resError.vue?vue&type=template&id=ce755256&scoped=true&"
import script from "./resError.vue?vue&type=script&lang=js&"
export * from "./resError.vue?vue&type=script&lang=js&"
import style0 from "./resError.vue?vue&type=style&index=0&id=ce755256&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce755256",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\mzkj\\要炼\\yl-pc-business\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ce755256')) {
      api.createRecord('ce755256', component.options)
    } else {
      api.reload('ce755256', component.options)
    }
    module.hot.accept("./resError.vue?vue&type=template&id=ce755256&scoped=true&", function () {
      api.rerender('ce755256', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/register/resident/resError.vue"
export default component.exports